module.exports = __webpack_public_path__ + "09dfd996aad75e6d975375ab4e04b331.svg";